import ticketApi from '../../api/ticket';
import types from '../mutation-types';

const state = {
    tickets: [],
    updateSaleValueTicket: {},
    kanbanFetchRequestId: 0,
};

export const getters = {
    getTickets(_state) {
        return _state.tickets;
    },
    getTicketSalueValueChange(_state) {
        return _state.updateSaleValueTicket
    }
};

export const actions = {
    async createTicket({ commit }, payload) {
        try {
            const response = await ticketApi.createTicket({ ticket: payload });
            commit(types.ADD_TICKET, response.data);
            return response.data;
        } catch (err) {
            throw new Error(err);
        }
    },

    async getTicket(_ctx, ticketId) {
        try {
            const response = await ticketApi.getTicket(ticketId);
            return response.data;
        } catch (err) {
            throw new Error(err);
        }
    },

    async getTicketsByKanban({ commit, state }, payload) {
        try {
            const { _requestId, ...apiParams } = payload;
            if (_requestId != null) {
                state.kanbanFetchRequestId = _requestId;
            }
            commit(types.CLEAN_TICKETS);
            const response = await ticketApi.getTickets(apiParams);
            if (_requestId != null && _requestId !== state.kanbanFetchRequestId) {
                return response.data;
            }
            commit(types.SET_TICKETS, response.data?.columns);
            return response.data;
        } catch (err) {
            throw new Error(err);
        }
    },

    async getTicketsByColumnColumns(_context, payload) {
        try {
            const response = await ticketApi.getTicketsByColumns(payload);
            return response.data;
        } catch (err) {
            throw new Error(err);
        }
    },

    async getTicketsByContactId({ commit }, contact_id) {
        try {
            commit(types.CLEAN_TICKETS);
            const response = await ticketApi.getTicketsByContact(contact_id);
            commit(types.SET_TICKETS, response.data);
        } catch (err) {
            throw new Error(err);
        }
    },

    async updateTicket({ commit }, payload) {
        try {
            const response = await ticketApi.updateTicket(payload.id, { ticket: payload });
            commit(types.UPDATE_TICKET, response.data);
            return response.data;
        } catch (err) {
            throw new Error(err);
        }
    },

    async bulkUpdateTicketColumns(_context, payload) {
        try {
            const response = await ticketApi.bulkUpdateTicketColumns(payload);
            return response.data;
        } catch (err) {
            throw new Error(err?.response?.data?.error || err?.message || err);
        }
    },

    async bulkUpdateTicketLabels(_context, payload) {
        try {
            const response = await ticketApi.bulkUpdateTicketLabels(payload);
            return response.data;
        } catch (err) {
            throw new Error(err?.response?.data?.error || err?.message || err);
        }
    },

    async bulkUpdateContactAttributes(_context, payload) {
        try {
            const response = await ticketApi.bulkUpdateContactAttributes(payload);
            return response.data;
        } catch (err) {
            throw new Error(err?.response?.data?.error || err?.message || err);
        }
    },

    async deleteTicket({ commit }, ticket_id) {
        try {
            const response = await ticketApi.deleteTicket(ticket_id);
            commit(types.REMOVE_TICKET, ticket_id);
            return response.data;
        } catch (err) {
            throw new Error(err);
        }
    },

    removeTicketFromState({ commit }, ticket_id) {
        commit(types.REMOVE_TICKET, ticket_id);
    },

    async getDashboardMetrics({ commit }, queryParams = '') {
        try {
            const response = await ticketApi.getDashboardMetrics(queryParams);
            return response;
        } catch (err) {
            throw new Error(err);
        }
    },

    async sendTicketCommunication(_ctx, { ticketId, communication }) {
        try {
            const response = await ticketApi.sendCommunication(ticketId, communication);
            return response.data;
        } catch (err) {
            throw new Error(err?.response?.data?.error || err);
        }
    },

    async getTicketContacts(_ctx, { ticketId }) {
        try {
            const response = await ticketApi.getContacts(ticketId);
            return response.data;
        } catch (err) {
            throw new Error(err?.response?.data?.error || err);
        }
    },

    async addTicketContact(_ctx, { ticketId, contactId }) {
        try {
            const response = await ticketApi.addContact(ticketId, contactId);
            return response.data;
        } catch (err) {
            throw new Error(err?.response?.data?.error || err);
        }
    },

    async removeTicketContact(_ctx, { ticketId, contactId }) {
        try {
            const response = await ticketApi.removeContact(ticketId, contactId);
            return response.data;
        } catch (err) {
            throw new Error(err?.response?.data?.error || err);
        }
    },

    changeSaleValueTicket({ commit }, data) {
        commit(types.UPDATE_SALUE_VALUE_TICKET, data);
    }
}

export const mutations = {
    [types.SET_TICKETS](state, data) {
        state.tickets = data.reverse();
    },

    [types.ADD_TICKET](state, data) {
        state.tickets.unshift(data);
    },
    [types.CLEAN_TICKETS](state) {
        state.tickets = []
    },
    [types.REMOVE_TICKET](state, ticket_id) {
        // Column-based removal (kanban board)
        state.tickets.forEach(item => {
            if (item.column && item.column.tickets) {
                const idx = item.column.tickets.findIndex(t => t.id === ticket_id);
                if (idx > -1) {
                    const saleValue = Number(item.column.tickets[idx].sale_value || 0);
                    item.column.tickets.splice(idx, 1);
                    item.column.meta.total_count = Math.max(0, (item.column.meta.total_count || 0) - 1);
                    item.column.meta.total_sales_value = (item.column.meta.total_sales_value || 0) - saleValue;
                }
            }
        });
        // Flat list removal
        state.tickets = state.tickets.filter(kf => kf.id !== ticket_id);
    },
    [types.UPDATE_TICKET](state, data) {
        const index = state.tickets.findIndex(
            ticket => ticket.id === data.id
        );
        if (index !== -1) {
            state.tickets.splice(index, 1, { ...state.tickets[index], ...data });
        }

        state.tickets.forEach(item => {
            if (item.column && item.column.tickets) {
                const tIndex = item.column.tickets.findIndex(t => t.id === data.id);
                if (tIndex !== -1) {
                    // Merge to preserve nested objects (e.g. contact) not returned by the update API
                    item.column.tickets.splice(tIndex, 1, { ...item.column.tickets[tIndex], ...data });
                }
            }
        });
    },
    [types.UPDATE_SALUE_VALUE_TICKET](state, data) {
        state.updateSaleValueTicket = data;
    },
}

export default {
    actions,
    state,
    getters,
    mutations,
};
